// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nav-tabs-custom .nav-item[data-v-c92f8cb8] {\n    white-space: nowrap;\n}\n.page-content.mystyle .form__body--card[data-v-c92f8cb8] {\n    max-width: 100%;\n    margin-left: 0;\n}\n.custom__table--sticky td[data-v-c92f8cb8]:last-child {\n    position: relative;\n    inset: 0;\n}\n", ""]);
// Exports
module.exports = exports;
